import './App.css';
import Wrapper from './components/Wrapper';
import Menu from './components/Menu';
import { Routes, Route, useLocation, Navigate, useNavigate } from 'react-router-dom';
import CategoryComponent from './components/CategoryComponent';
import AddItemComponent from './components/AddItemComponent';
import ApprovedComponent from './components/ApprovedComponent';
import { useSelector } from 'react-redux';
import EditItemComponent from './components/EditItemComponent';
import Login from './Auth';
import ForgotPassword from './ForgotPassword';
import SetPassword from './SetPassword';
import Alert from './components/Alert';
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from 'react';
import { getRoleNames } from './utils/roleUtils';
import { useGetRolesQuery } from './store/services/rolesServices';
import Homepage from './components/Homepage';
import { Test2Component } from './components/Test2Component';
import { GameComponent } from './components/game_rules/GameComponent';
import SubCategoryComponent from './components/SubCategoryComponent';
import ReceiptDrawLab from './components/ReceiptDrawLab/ReceiptDrawLab';

function App() {

  const isModalOpen = useSelector(state => state.modal.isOpen)
  const isAlertOpen = useSelector(state => state.alert.isOpen)
  const { data: rolesData } = useGetRolesQuery()
  const location = useLocation();
  // Pages reachable while logged out
  const isLoginPage = ['/login', '/forgot-password', '/set-password'].includes(location.pathname);
  const token = localStorage.getItem('giz_superaccess')
  const [hasValidRole, setHasValidRole] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    if (token && rolesData?.data) {
      const user = jwtDecode(token);
      const validRoles = getRoleNames(rolesData.data);
      if (validRoles.includes(user.role)) {
        setHasValidRole(true)
      }
    }
  }, [token, rolesData])

  useEffect(() => {
    console.log({ hasValidRole })
  }, [hasValidRole])

  return (
    <Wrapper>
      <Alert />
      {/* <ReactModal /> */}
      {/* {!isLoginPage && isModalOpen && <DeleteModal />} */}
      {isLoginPage ? (
        token && hasValidRole ? (
          <Navigate to="/" replace />
        ) : (
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/set-password" element={<SetPassword />} />
          </Routes>
        )) : token && hasValidRole ? (
          <div className="flex relative">
            <div className="md:h-dvh md:p-4 md:sticky md:top-0">
              <Menu />
            </div>
            <div className="flex-grow bg-white pt-16 px-4 pb-4 md:p-4 md:pl-0 min-h-dvh">
              <div className="w-full h-full border border-gray-200 rounded-xl relative">
                <Routes>
                  <Route path="/" element={<Homepage />} />
                  <Route path="/:category" element={<CategoryComponent />} />
                  <Route path="/:category/add" element={<AddItemComponent />} />
                  <Route path="/:category/add/:game" element={<GameComponent />} />
                  <Route path="/:category/approved" element={<ApprovedComponent />} />
                  <Route path="/:category/:id/edit" element={<EditItemComponent />} />,
                  <Route path="/:category/:subcategory/" element={<SubCategoryComponent />} />
                  <Route path="/:category/:subcategory/:id/edit" element={<EditItemComponent />} />
                  <Route path="/test2" element={<Test2Component />} />
                  <Route path="/draw-lab" element={<ReceiptDrawLab />} />
                  {/* Add a catch-all route for 404 here if needed */}
                </Routes>
              </div>
            </div>
          </div>
        ) : (
        <Routes>
          <Route path="*" element={!token && !hasValidRole && <Navigate to="/login" />} />
        </Routes>
      )}
    </Wrapper>
  );
}

export default App;
